import React from 'react';
import { ScrollReveal } from './ScrollReveal';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 px-4 bg-[#050510]" data-id="element-69">
      <div className="container mx-auto max-w-3xl" data-id="element-70">
        <ScrollReveal data-id="element-71">
          <div className="glass-card p-8 md:p-12 rounded-3xl border border-white/10 text-center relative overflow-hidden" data-id="element-72">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-cyan-400 to-purple-500" data-id="element-73" />

            <div className="w-20 h-20 bg-white/5 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-74">
              <ShieldCheck className="w-10 h-10 text-white" data-id="element-75" />
            </div>

            <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-76">
              Garantía de 7 Días
            </h2>
            <p className="text-gray-300 mb-6 text-lg" data-id="element-77">
              Tienes 7 días completos para probar el programa. Si sientes que no
              es para ti, te devolvemos el 100% de tu dinero. Sin preguntas.
            </p>

            <p className="text-sm text-gray-500 uppercase tracking-widest font-bold" data-id="element-78">
              Riesgo Cero para ti
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}